export const DEFAULT_COOKIE_CONSENT_URL: string =
    'https://consent.trustarc.com/notice?domain=blackhawknetwork.com&c=teconsent&js=nj&noticeType=bb&text=true&gtm=1';
export const FAQ_KYC_PARMS: string = 'kyc';
export const FAQ_KYC_SUB_HEADER: string = 'ID Verification';
export const MPC: string = 'MPC';
export const ACTION: string = 'provision';
